import { useUnit } from 'effector-react';
import { useProductParams } from '../../../../hooks/useProductParams';
import { useTranslation } from 'react-i18next';

import InfoSection from './InfoSection';
import RatingBar from '../../RatingBar/RatingBar';
import { EProducts } from '../../../../model/enums';
import { $cartState } from '../../../../store/models/cart';
import OrderFrequency from '../../OrderFrequency/OrderFrequency';
import ProductItemPayment from '../ProductItemPayment/ProductItemPayment';
import GrassSizeSelectBar from '../../GrassSizeSelectBar/GrassSizeSelectBar';

import styles from './styles.module.scss';

const ControlBar = () => {
  const { t } = useTranslation();
  const { productType, productSize } = useProductParams();

  const { selectedProductSize } = useUnit($cartState);
  const size = selectedProductSize || productSize;
  let title = '';

  switch (productType) {
    case EProducts.grs:
      title = 'Fresh Grass';
      break;
    case EProducts.acs:
      title = 'Plastic Tray';
      break;
    case EProducts.ctn:
      title = 'Catnip';
      break;
    case EProducts.sds:
      title = 'Catgrass Seeds';
      break;
    default:
      title = 'Unknown';
      break;
  }

  return (
    <div className={styles.controlBar}>
      <h1>
        {title} {productType !== EProducts.sds ? `(${size})` : ''}
      </h1>
      <div className={styles.reviewsWrapper}>
        <RatingBar rating={5} />
        <span>15 {t('reviews')}</span>
      </div>
      {productType === EProducts.grs && <GrassSizeSelectBar />}
      {(productType === EProducts.grs || productType === EProducts.sds)  && <OrderFrequency />}

      <ProductItemPayment />
      <InfoSection />
    </div>
  );
};

export default ControlBar;
